import React, { Component } from 'react';
import Analytics from 'react-ga';
import ContentSection from '../ContentSection';
import Navbar from '../Navbar';
import firstAidStratImage from './assets/first-aid-strat.png';
import xrayImage from './assets/doctor-guitar-xray.png';
import './styles.css';

export default class RepairPage extends Component {

  componentDidMount() {

    Analytics.pageview('/repair');
  }

  render() {
    return (
      <Navbar location={this.props.location}>
        <div className="repair-page">
          <ContentSection className="free-repair-section">
            <h1>Free Repair & Maintenance for the First Year</h1>
            <div className="free-repair-description-container">
              <p className="free-repair-description">
                When you buy a guitar at McGuire Music, we make sure that everything is working properly and that you are enjoying your new instrument. For the first year you own your new instrument, McGuire Music will adjust, re-solder, or tighten to help maintain it at no charge! (Parts, strings, and re-string charges are not included.)
              </p>
              <div className="first-aid-strat">
                <img src={firstAidStratImage} alt="guitar first aid" title="Get it? It's like first aid! For your guitar!"/>
              </div>
            </div>
          </ContentSection>
          <ContentSection className="repair-services-section" containerClassName="theme-background">
            <h1>Repair & Maintenance Services</h1>
            <div className="repair-services-description-container">
              <div className="guitar-x-ray">
                <img src={xrayImage} alt="A guy x-raying a guitar" title="We make Beejay wear scrubs in the shop."/>
              </div>
              <div className="repair-services-description">
                We offer a variety of repair and maintenance services for guitars and other stringed instruments.
                <ul>
                  <li>Set-ups</li>
                  <li>String replacement</li>
                  <li>Nut and saddle replacement</li>
                  <li>Pickup installation</li>
                  <li>Electronic repair</li>
                  <li>and more!</li>
                </ul>
              </div>
            </div>
          </ContentSection>
        </div>
      </Navbar>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/RepairPage/index.js